import { Navigate } from 'react-router-dom';

export const Redirect = () => {
  return <Navigate to="/personal-offer/my-view" />;
};

export default Redirect;
